import api from './api';

export const pendentes = () => api.get('suprimentos/pendentes');
export const concluidos = () => api.get('suprimentos/concluidos');
export const changeComprador = (values: any) => api.put('suprimentos/changeComprador', values);
